import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import {
	MockupWindow,
	BoardMockup,
	PlanMockup,
	TeamMockup,
	AssistantMockup,
} from "@/pages/Public/components/ProductMockups";

type ShowcaseFeature = {
	kicker: string;
	title: string;
	description: string;
};

const VISUALS: ReactNode[] = [
	<PlanMockup key="plan" />,
	<BoardMockup key="board" />,
	<TeamMockup key="team" />,
	<AssistantMockup key="assistant" />,
];

export default function LandingProductShowcaseSection() {
	const { t } = useTranslation();
	const ts = (key: string) => t(`questionnaire.landingProductShowcase.${key}`);

	const features = t("questionnaire.landingProductShowcase.features", {
		returnObjects: true,
	}) as ShowcaseFeature[];

	return (
		<section className="w-full px-4 md:px-0 bg-surface">
			<div className="w-full max-w-[1420px] mx-auto py-16 sm:py-[7.5rem] px-4 md:px-16 flex flex-col gap-16 sm:gap-24">
				<div className="flex flex-col gap-6 text-center max-w-[860px] mx-auto">
					<h2 className="font-urbanist text-[40px] font-semibold leading-[120%] text-ink">
						{ts("title")}
					</h2>
					<p className="font-urbanist text-[18px] font-normal leading-[150%] text-subtle">
						{ts("description")}
					</p>
				</div>

				{features?.map((feature, index) => (
					<div
						key={feature.title}
						className={`flex flex-col gap-10 lg:gap-20 items-center ${
							index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
						}`}
					>
						<div className="flex flex-col gap-4 w-full lg:w-1/2 max-w-[560px]">
							<p className="font-urbanist text-[14px] font-bold tracking-[0.08em] text-accent-strong">
								{feature.kicker}
							</p>
							<h3 className="font-urbanist text-[28px] md:text-[32px] font-semibold leading-[125%] text-ink">
								{feature.title}
							</h3>
							<p className="font-urbanist text-[18px] font-normal leading-[150%] text-subtle">
								{feature.description}
							</p>
						</div>
						<div className="w-full lg:w-1/2 max-w-[620px]">
							<MockupWindow>{VISUALS[index]}</MockupWindow>
						</div>
					</div>
				))}
			</div>
		</section>
	);
}
